// extracted by mini-css-extract-plugin
export default {"loggedOutHeading":"_2tyqO2dKL3aemCNz3kfU-t","mfaLoggedOutHeading":"GDFWcon91H5K_MSumMs-X","buttonStart":"_2eaUCx4Sww39JfF9Y38cGZ"};